import React, { useEffect, useState } from 'react';
import { Admin, Resource, ListGuesser, EditGuesser, Create, Pagination, List, Datagrid, TextField } from 'react-admin';
import { authProvider, handleAuthCallback } from './providers/authProvider';
import { dataProvider } from './providers/dataProvider';
import LoginPage from './components/LoginPage';
import { UserList, UserEdit, UserCreate } from './resources/Users';
import { TemplateBundleList, TemplateBundleEdit, TemplateBundleCreate } from './resources/TemplateBundles';
import { FeedbackList, FeedbackEdit, FeedbackCreate } from './resources/Feedbacks';

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Handle OAuth callback on app load
    const hasToken = handleAuthCallback();

    // Check if user is authenticated
    authProvider.checkAuth()
      .then(() => setIsAuthenticated(true))
      .catch(() => setIsAuthenticated(false))
      .finally(() => setIsLoading(false));
  }, []);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return (
    <Admin
      dataProvider={dataProvider}
      authProvider={authProvider}
      requireAuth
    >
      <Resource
        name="users"
        list={UserList}
        edit={UserEdit}
        create={UserCreate}
      />
      <Resource
        name="template_bundles"
        list={TemplateBundleList}
        edit={TemplateBundleEdit}
        create={TemplateBundleCreate}
      />
      <Resource
        name="companies"
        list={(props) => <ListGuesser {...props} pagination={<Pagination />} />}
        edit={EditGuesser}
        create={Create}
      />
      <Resource
        name="documents"
        list={(props) => <ListGuesser {...props} pagination={<Pagination />} />}
        edit={EditGuesser}
        create={Create}
      />
      <Resource
        name="tags"
        list={(props) => <ListGuesser {...props} perPage={10} pagination={<Pagination />} />}
        edit={EditGuesser}
        create={Create}
      />
      <Resource
        name="features"
        list={(props) => <ListGuesser {...props} perPage={10} pagination={<Pagination />} />}
        edit={EditGuesser}
        create={Create}
      />
      <Resource
        name="feedbacks"
        list={FeedbackList}
        edit={FeedbackEdit}
        create={FeedbackCreate}
      />
      <Resource
        name="news_letters"
        list={(props) => <ListGuesser {...props} pagination={<Pagination />} />}
        edit={EditGuesser}
        create={Create}
      />
      <Resource
        name="news_subscribers"
        list={(props) => <ListGuesser {...props} pagination={<Pagination />} />}
        edit={EditGuesser}
        create={Create}
      />
      <Resource
        name="pdf_requests"
        list={(props) => <ListGuesser {...props} pagination={<Pagination />} />}
        edit={EditGuesser}
        create={Create}
      />
      <Resource
        name="boxelements"
        list={(props) => <ListGuesser {...props} pagination={<Pagination />} />}
        edit={EditGuesser}
        create={Create}
      />
      <Resource
        name="teacher_profiles"
        list={(props) => <ListGuesser {...props} pagination={<Pagination />} />}
        edit={EditGuesser}
        create={Create}
      />
      <Resource
        name="billings"
        list={(props) => <ListGuesser {...props} pagination={<Pagination />} />}
        edit={EditGuesser}
        create={Create}
      />
      <Resource
        name="plans"
        list={(props) => <ListGuesser {...props} pagination={<Pagination />} />}
        edit={EditGuesser}
        create={Create}
      />
      <Resource
        name="dictionaries"
        list={(props) => <ListGuesser {...props} pagination={<Pagination />} />}
        edit={EditGuesser}
        create={Create}
      />
      <Resource
        name="dictionary_assets"
        list={(props) => <ListGuesser {...props} pagination={<Pagination />} />}
        edit={EditGuesser}
        create={Create}
      />
      <Resource
        name="pdf_assets"
        list={(props) => <ListGuesser {...props} pagination={<Pagination />} />}
        edit={EditGuesser}
        create={Create}
      />
      <Resource
        name="cover_images"
        list={(props) => <ListGuesser {...props} pagination={<Pagination />} />}
        edit={EditGuesser}
        create={Create}
      />
      <Resource
        name="template_bundle_views"
        list={(props) => <ListGuesser {...props} pagination={<Pagination />} />}
      />
      <Resource
        name="template_bundle_solds"
        list={(props) => <ListGuesser {...props} pagination={<Pagination />} />}
      />
    </Admin>
  );
};

export default App;
